<template>
  <button
    class="block w-full px-4 py-2 text-sm leading-5 text-gray-700 hover:text-gray-900 disabled:text-gray-400 text-left hover:bg-gray-100 disabled:cursor-not-allowed"
    role="menuitem"
    @click="$parent.$emit('actions-menu:close'); $emit('click', $event);"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "ActionsItem",
};
</script>
